module.exports = __webpack_public_path__ + "static/media/USDT-BUSD.f1a73e05.svg";